import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Input,
    Modal,
    ModalClose,
    ModalDialog,
    Typography,
} from '@mui/joy'
import { useApi } from 'api'
import { useShowSnack } from 'components/snackbar'
import { prop } from 'ramda'
import { useState } from 'react'
import { useListingContext } from '../listingProvider'

interface Props {
    open: boolean
    onClose: () => void
    formType: string
    documentId?: string
    title?: string
    message?: string
}

const AbandonFormModal = ({
    open,
    onClose,
    formType,
    documentId,
    title = 'Delete Document',
    message = 'Are you sure you want to delete this document? This action cannot be undone.',
}: Props) => {
    const { listing, setListing } = useListingContext()
    const showSnack = useShowSnack()
    const api = useApi()

    const [loading, setLoading] = useState(false)
    const [reason, setReason] = useState('')

    const handleClose = () => {
        setReason('')
        onClose()
    }

    const handleAbandon = async () => {
        console.log('handleAbandon')

        setLoading(true)
        try {
            let response
            if (formType === 'generic') {
                response = await api
                    .post(`/listing/sale/${listing.listingId}/annature/delete`, {
                        formType: 'generic',
                        formId: documentId,
                        reason,
                    })
                    .then(prop('data'))
            } else {
                // For existing DocuSign forms, use the existing endpoint
                response = await api
                    .post(`/listing/sale/${listing.listingId}/annature/delete`, {
                        formType,
                        reason,
                    })
                    .then(prop('data'))
            }

            setListing(response.updatedListing)
            showSnack('Document deleted successfully', 'success')
            handleClose()
        } catch (error) {
            console.error('Error deleting document:', error)
            showSnack('Error deleting document', 'danger')
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
        >
            <ModalDialog>
                <ModalClose />
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <Typography sx={{ mb: 2 }}>{message}</Typography>
                    <Typography
                        level="body-sm"
                        sx={{ mb: 1 }}
                    >
                        Reason
                    </Typography>
                    <Input
                        placeholder="Please provide a reason for deleting this document..."
                        value={reason}
                        onChange={e => setReason(e.target.value)}
                        sx={{ width: '100%' }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        loading={loading}
                        color="danger"
                        onClick={handleAbandon}
                        disabled={!reason.trim()}
                    >
                        Abandon
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </ModalDialog>
        </Modal>
    )
}

export default AbandonFormModal
